import { debounce } from 'lodash';

export const SEARCH_TELEMETRY_DEBOUNCE_MS = 500;

export type SearchTelemetryChange = { action: 'set' } | { action: 'clear' };

export type SettledSearchResult = {
  within: number;
  outside: number;
  matchedLayerIds: string[];
};

export function searchEventProperties(change: SearchTelemetryChange, result: SettledSearchResult) {
  if (change.action === 'clear') return { action: 'clear' as const };

  return {
    action: 'set' as const,
    within_match_count: result.within,
    outside_match_count: result.outside,
    matched_layer_ids: result.matchedLayerIds,
  };
}

// reports at most one event per query
export function createSearchTelemetry(
  report: (change: SearchTelemetryChange) => void,
  delayMs = SEARCH_TELEMETRY_DEBOUNCE_MS,
) {
  let previousTerm = '';
  const reportSettled = debounce(() => report({ action: 'set' }), delayMs);

  return {
    termChanged(term: string) {
      const previous = previousTerm;
      previousTerm = term;
      if (term === previous) return;

      if (term === '') {
        reportSettled.cancel();
        report({ action: 'clear' });
        return;
      }

      reportSettled();
    },
    /** Drop a query still waiting to settle, e.g. when the picker unmounts. */
    dispose() {
      reportSettled.cancel();
    },
  };
}
